import React from 'react';

const CartItem = ({ item, index, removeFromCart, updateQuantity, darkMode }) => {
  return (
    <div
      className={`rounded-lg shadow-md p-4 mb-4 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}
    >
      <div className="flex">
        <img
          src={item.rack.photo[0]}
          alt={item.rack.name}
          className="w-20 h-20 object-cover rounded-lg mr-4"
        />
        <div className="flex-1">
          <h3 className="font-semibold">{item.rack.name}</h3>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            {item.car.brand} {item.car.model}, {item.car.modification}, {item.car.roofType}
          </p>

          <div className="flex justify-between items-center mt-1">
            <p className="font-bold">
              {item.rack.price.toLocaleString()} ₽
              {item.rack.needsAdapter && (
                <span className={`text-sm font-normal ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  {' '}+ {item.rack.adapterPrice.toLocaleString()} ₽
                </span>
              )}
            </p>

            <div className="flex items-center">
              <button
                onClick={() => updateQuantity(index, item.quantity - 1)}
                className={`w-8 h-8 flex items-center justify-center rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}
                disabled={item.quantity <= 1}
                aria-label="Уменьшить количество"
              >
                <i className="fas fa-minus text-sm" aria-hidden="true"></i>
              </button>
              <span className="mx-3" aria-label="Количество">{item.quantity}</span>
              <button
                onClick={() => updateQuantity(index, item.quantity + 1)}
                className={`w-8 h-8 flex items-center justify-center rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}
                aria-label="Увеличить количество"
              >
                <i className="fas fa-plus text-sm" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <button
          onClick={() => removeFromCart(index)}
          className="text-red-500 hover:text-red-700 self-start"
          aria-label="Удалить из корзины"
        >
          <i className="fas fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default CartItem;